import { IonTitle, IonToolbar, IonButtons, IonCheckbox, IonItem, IonButton } from '@ionic/react';
import './index.css';
import { FieldError, NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../common';
import React from 'react';
import { withTranslation } from '../../lib/translate';
import Modal from '../modal';
import { getConfig } from '../../appConfig';
import Basket from '../../lib/basket';

class CheckoutAllergens extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpened: false,
            allergenList: Basket.allergen_list ?? [],
            hasAllergens: Basket.allergen_list?.length >= 0 ? Basket.allergen_list?.length >= 1 : null
        }
    }

    updateAllergensData = (item) => {
        this.setState((prevState) => {
            const isSelected = prevState.allergenList.includes(item);

            return {
                allergenList: isSelected
                    ? prevState.allergenList.filter((i) => i !== item)
                    : [...prevState.allergenList, item],
            };
        });
    }
    render() {
        const { __, allergenError, isAlreadyCreatedOrder, allergens } = this.props
        const { modalOpened, hasAllergens, allergenList } = this.state;
        let error = !Array.isArray(Basket.allergen_list) && allergenError
        return (
            <>
                {isAlreadyCreatedOrder ? <>
                    {allergens?.length > 0 &&
                        <>
                            <div className='checkout-allergens-wrapper'>
                                <StrongText className='text-to-update'>{__('Allergy information')}</StrongText>
                                <div className='box-content'>
                                    <div className='allergen-pills-wrapper'>
                                        {allergens.map(el => (
                                            <div ><SmallText className='label-color'>{el}</SmallText></div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                            <Spacer size={5} />
                        </>
                    }
                </> : <>
                    <Spacer size={5} />

                    <div className='checkout-allergens-wrapper'>
                        <StrongText className='text-to-update'>{__('Allergy information')}</StrongText>
                        <Spacer size={1} />
                        <div className={`box-content ${error ? 'box-content-error' : ''}`}>
                            <NormalText className='label-color'>{__('Do you have any allergies?')}</NormalText>
                            <Spacer size={3} />
                            <div className='allergen-options-wrapper'>

                                <div className={`${hasAllergens == false ? 'selected' : ''}`} onClick={() => {
                                    Basket.setAllergenList([])

                                    this.setState({ allergenList: [], hasAllergens: false })
                                }}><SmallText className='label-color'>{__('No allergies')}</SmallText></div>
                                <div className={`${hasAllergens ? 'selected' : ''}`} onClick={() => { if (!this.state.hasAllergens) { this.setState({ modalOpened: true }) } }}><SmallText className='label-color'>{__('Yes, I have allergies')}</SmallText></div>

                            </div>
                            {error &&
                                <FieldError className="field-error" value={__('Please select an option')} />

                            }

                            {hasAllergens &&
                                <div>
                                    <Spacer size={3} />

                                    <div className='allergen-pills-wrapper'>
                                        {allergenList.map(el => (
                                            <div ><SmallText className='label-color'>{el}</SmallText></div>
                                        ))}
                                    </div>

                                    <Spacer size={3} />
                                    <div className='centered' onClick={() => this.setState({ modalOpened: true })}>
                                        <StrongText className={'block'}>{__('EDIT ALLERGIES')}</StrongText>

                                    </div>
                                </div>
                            }
                        </div>
                        <Spacer size={2} />
                        <SmallText className='label-color text-to-update block centered'>{__("We handle allergens and use shared equipment so can't guarantee our food or drinks are allergen free")}</SmallText>
                        <Spacer size={2} />
                        <Modal className="modal-type-alert" onDidDismiss={() => this.setState({ modalOpened: false })} isOpen={modalOpened}>
                            <Title>{__('Select allergies')}</Title>
                            <NormalText className='text-to-update'>{__('We handle allergens and use shared equipment so can’t guarantee our food or drinks are allergen free')}</NormalText>
                            <Spacer size={5} />
                            <div className='allergens-data'>
                                {getConfig().general.allergenList.map(el => (
                                    <IonItem lines='none' className='box-content'>
                                        <IonCheckbox checked={this.state.allergenList.includes(el)} onIonChange={() => this.updateAllergensData(el)} labelPlacement="end" >
                                            <NormalText>{__(el)}</NormalText>
                                        </IonCheckbox>
                                    </IonItem>

                                ))}


                            </div>
                            <Spacer size={5} />

                            <IonButton onClick={() => {
                                this.setState({ modalOpened: false, hasAllergens: this.state.allergenList.length > 0 ? true : null }, () => {
                                    Basket.setAllergenList(this.state.hasAllergens ? this.state.allergenList : null)
                                })
                            }} expand='block'>{__('Continue')}</IonButton>

                        </Modal>
                    </div>

                </>}
            </>
        );
    }

};
export default withTranslation(CheckoutAllergens);

